/**
 *
 * @module identity
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString
} = Check.assert;

/**
 *
 * @class Identity
 * @since 3.5.0
 *
 */
export default class Identity {

    /**
     *
     * @param {String} identityId
     * @param {String} providerId
     * @throws {InvalidArgumentException}
     *
     */
    constructor(identityId, providerId) {

        const errorMessage = {
            ctor: 'Identity(identityId, providerId)',
            get identityId() {
                return `${this.ctor} identityId should be a String with length`;
            },
            get providerId() {
                return `${this.ctor} providerId should be a String with length`;
            }
        };

        nonEmptyString(identityId, errorMessage.identityId, InvalidArgumentException);
        nonEmptyString(providerId, errorMessage.providerId, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.identityId = identityId;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.providerId = providerId;

    }

}



// WEBPACK FOOTER //
// ./src/services/account/identity.js